import { Instagram, LucideIcon, Send, Youtube } from 'lucide-react';

export const TELEGRAM_URL = 'https://t.me/carton_market';

export const CUSTOMER_LINKS = [
    { label: 'Продавці', href: '/sellers' },
    { label: 'Блог', href: '/blog' },
    { label: 'Оновлення', href: '/changelog' },
    { label: "Зв'яжіться з нами", href: '/contact' },
    { label: 'FAQ', href: '/faq' },
    { label: 'Умови використання', href: '/terms' },
    { label: 'Про нас', href: '/about' },
    { label: 'Політика конфіденційності', href: '/privacy' },
] as const;

export const SOCIAL_LINKS = [
    {
        label: 'Telegram',
        href: TELEGRAM_URL,
        icon: Send,
    },
    {
        label: 'Instagram',
        href: 'https://www.instagram.com/carton.cards/',
        icon: Instagram,
    },
    {
        label: 'YouTube',
        href: 'https://www.youtube.com/@cartoncards',
        icon: Youtube,
    },
] as const satisfies ReadonlyArray<{
    label: string;
    href: string;
    icon: LucideIcon;
}>;
